 
/**
 * Returns a string containing the errors messages from fetch response:
 *
 * @param {Object} FetchError - Object. Contains fetch error data.
 * @param {Object} intl - (Optional) Object. Contains internationalization messages. DefaultValue = null.
 *
 * @returns {String} Stringed array of errors.
 */

export default (FetchError, intl = null) => {
  if (typeof FetchError?.payload === 'string') {
    //if provided and present in intl object can be returned an intl translation
    return intl && intl.messages[FetchError?.payload]
      ? intl.messages[FetchError?.payload]
      : FetchError?.payload;
  }

  return FetchError?.payload?.errors
    ?.map((err) => {
      if (typeof err === 'string') {
        //if provided and present in intl object can be returned an intl translation
        return intl && intl.messages[err] ? intl.messages[err] : err;
      }
      return intl && err?.code && intl.messages[err?.code]
        ? intl.messages[err.code]
        : err?.description
          ? err?.description
          : err?.code;
    })
    ?.toString();
};
